<template>
    <return-button />
    <div class="main-container">
        <div class="title-header">
            <h1 class="title">Datos generales del paciente</h1>
        </div>
        <div class="content-container">
            <v-form ref="form" v-model="inputPatientForm">
                <v-row>
                    <v-col cols="12" md="9"
                        ><v-row>
                            <v-col cols="12" md="4" class="d-flex">
                                <v-icon class="field-icon"
                                    >mdi-account-outline</v-icon
                                >
                                <v-text-field
                                    class="field-input"
                                    v-model="patientName"
                                    @input="formatText('patientName')"
                                    :rules="inputTextRules"
                                    :counter="30"
                                    variant="outlined"
                                    persistent-placeholder
                                    placeholder=" "
                                    required>
                                    <template #label>
                                        <span class="field-label">
                                            Nombre<span class="required"
                                                >*</span
                                            >
                                        </span>
                                    </template>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    class="field-input"
                                    v-model="fatherLastName"
                                    @input="formatText('fatherLastName')"
                                    :rules="inputTextRules"
                                    :counter="30"
                                    variant="outlined"
                                    persistent-placeholder
                                    placeholder=" "
                                    required>
                                    <template #label>
                                        <span class="field-label">
                                            Primer apellido<span
                                                class="required"
                                                >*</span
                                            >
                                        </span>
                                    </template>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    class="field-input"
                                    v-model="motherLastName"
                                    @input="formatText('motherLastName')"
                                    :rules="motherLastNameRules"
                                    :counter="30"
                                    variant="outlined"
                                    persistent-placeholder
                                    placeholder=" "
                                    required>
                                    <template #label>
                                        <span class="field-label">
                                            Segundo apellido
                                        </span>
                                    </template>
                                </v-text-field>
                            </v-col>
                        </v-row></v-col
                    >
                    <v-col cols="12" md="3">
                        <v-row class="d-flex justify-center">
                            <v-col
                                cols="12"
                                class="d-flex justify-center align-center">
                                <v-icon class="field-icon mr-4"
                                    >mdi-gender-male-female</v-icon
                                >
                                <span class="required-field-icon mr-3">*</span>
                                <v-radio-group
                                    v-model="patientGender"
                                    :rules="genderRules"
                                    inline
                                    class="d-flex align-center"
                                    required>
                                    <v-radio
                                        label="Masculino"
                                        value="Masculino"
                                        class="field-label mr-6" />
                                    <v-radio
                                        label="Femenino"
                                        value="Femenino"
                                        class="field-label" />
                                </v-radio-group>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="3" class="d-flex">
                        <v-icon class="field-icon">mdi-calendar</v-icon>
                        <v-text-field
                            class="field-input"
                            v-model="birthDate"
                            :rules="dateRules"
                            variant="outlined"
                            @input="formatDate"
                            hint="Formato DD/MM/AAAA"
                            persistent-placeholder
                            placeholder=" "
                            required>
                            <template #label>
                                <span class="field-label">
                                    Fecha de nacimiento<span class="required"
                                        >*</span
                                    >
                                </span>
                            </template>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="9">
                        <v-row>
                            <v-col cols="9" md="6">
                                <v-text-field
                                    v-model="patientPhone"
                                    variant="outlined"
                                    class="field-input"
                                    :rules="getRules('Teléfono')"
                                    persistent-placeholder
                                    placeholder=" ">
                                    <template #label>
                                        <span class="field-label">
                                            Teléfono
                                        </span>
                                    </template></v-text-field
                                >
                            </v-col>
                            <v-col cols="9" md="6">
                                <v-text-field
                                    v-model="patientEmail"
                                    variant="outlined"
                                    class="field-input"
                                    :rules="getRules('Correo')"
                                    persistent-placeholder
                                    placeholder=" ">
                                    <template #label>
                                        <span class="field-label">
                                            Correo electrónico
                                        </span>
                                    </template></v-text-field
                                >
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="4" class="d-flex">
                        <v-icon class="field-icon">mdi-account-hard-hat</v-icon>
                        <v-text-field
                            class="field-input"
                            v-model="patientOccupation"
                            :rules="patientOccupationRules"
                            :counter="40"
                            variant="outlined"
                            persistent-placeholder
                            placeholder=" "
                            required>
                            <template #label>
                                <span class="field-label"> Ocupación </span>
                            </template>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="3" class="d-flex">
                        <!-- <v-icon class="field-icon"
                            >mdi mdi-card-account-details</v-icon
                        >
                        <v-text-field
                            v-model="patientCard"
                            :counter="15"
                            :maxlength="15"
                            variant="outlined"
                            @input="formatCardInput">
                            <template #label>
                                <span class="field-label">
                                    # de Pastillero de Recompensas
                                    <v-icon class="field-icon" style="margin: 0"
                                        >mdi-information</v-icon
                                    >
                                </span>
                            </template>
                        </v-text-field> -->
                    </v-col>
                    <v-col
                        v-if="!loadPatientInfo"
                        cols="12"
                        md="5"
                        class="d-flex justify-end align-center">
                        <button
                            type="button"
                            class="boton-principal"
                            style="width: 344px; height: 36px; color: white"
                            @click="enviarFormulario"
                            :disabled="!inputPatientForm || isSubmitting">
                            <v-icon left>mdi-content-save</v-icon>
                            Guardar paciente e ir a consulta
                        </button>
                    </v-col>
                    <v-col
                        v-else
                        cols="12"
                        md="5"
                        class="d-flex justify-end align-center">
                        <button
                            type="button"
                            class="boton-principal"
                            style="width: 344px; height: 36px; color: white"
                            @click="enviarFormulario"
                            :disabled="!inputPatientForm || isSubmitting">
                            <v-icon left>mdi-content-save</v-icon>
                            Guardar paciente
                        </button>
                    </v-col>
                </v-row>
                <!-- <v-checkbox
                    style="font-family: var(--font-body)"
                    v-model="notificationsCheckbox"
                    label="Recibir notificaciones a partir de su medio de contacto">
                </v-checkbox> -->
            </v-form>
        </div>
    </div>
    <v-dialog v-model="contactDialog" max-width="500" @update:model-value="(val) => { if (!val) noContactCheckbox = false }">
        <v-row justify="center">
            <v-card class="h-2" style="width: 100%">

                <v-card-title> Guardar paciente</v-card-title>
                <v-card-text class="text-left px-6" style="margin-top: 15px; font-size: 1.1rem; color: #4a5568;">
                    ¿Estás seguro que quieres guardar este expediente sin
                    contacto?
                </v-card-text>
                <v-card-text class="d-flex justify-start pb-6 px-6">
                    <v-sheet
                        elevation="0"
                        class="px-4 py-3 rounded-lg d-flex align-center w-100"
                        style="border: 1px solid #cbd5e1; transition: all 0.2s ease; cursor: pointer;"
                        :style="noContactCheckbox ? 'border-color: #40b4e5; background-color: #f0f9ff;' : 'background-color: #f8fafc;'"
                        @click="noContactCheckbox = !noContactCheckbox"
                    >
                        <v-checkbox
                            v-model="noContactCheckbox"
                            color="#40b4e5"
                            hide-details
                            class="mt-0"
                            style="pointer-events: none;"
                        >
                            <template v-slot:label>
                                <span style="font-size: 1.05rem; color: #334155; font-weight: 500; margin-left: 8px;">
                                    El paciente no quiso dar su contacto
                                </span>
                            </template>
                        </v-checkbox>
                    </v-sheet>
                </v-card-text>

                <v-card-actions class="d-flex justify-space-between px-6 pb-4">
                    <v-btn color="error" variant="text" @click="(contactDialog = false), (noContactCheckbox = false)">
                        Regresar
                    </v-btn>
                    <v-btn color="#40b4e5" @click="validarFormulario()" :disabled="!noContactCheckbox">
                        Guardar paciente e ir a consulta
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-row>
    </v-dialog>
    <v-dialog v-model="duplicateDialog" persistent>
        <v-row justify="center">
            <v-card class="h-2" style="width: 60%">
                <i
                    class="mdi mdi-close-circle boton-cerrar-x"
                    style="
                        position: absolute;
                        top: 10px;
                        right: 10px;
                        float: right;
                        font-size: 25px;
                        cursor: pointer;
                        color: white;
                    "
                    @click="duplicateDialog = false"></i>
                <v-card-title>Paciente ya registrado</v-card-title>
                <v-card-text class="text-center" style="margin-top: 15px">
                    Este número de telefono ya fue registrado previamente. ¿Deseas continuar con el registro de todos modos?
                </v-card-text>

                <v-card-actions class="justify-center">
                    <v-btn color="error" @click="duplicateDialog = false">
                        Cancelar
                    </v-btn>
                    <v-btn color="#40b4e5" @click="submitWithBypass()">
                        Continuar de todos modos
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-row>
    </v-dialog>
    <v-snackbar
        :timeout="4000"
        :color="snackbarColor"
        variant="outlined"
        v-model="snackbar">
        <span>{{ snackbarMessage }}</span>
    </v-snackbar>
</template>

<script>
import returnButton from '@/components/global/return-button.vue';
import { formatText } from '@/utils/converte_text';
import { formatDate, validateDate } from '@/utils/converte_date';
import { getPatientById, putPacientes, postPaciente } from '@/api/pacientes';

export default {
    components: {
        'return-button': returnButton,
    },
    data() {
        const reglasComunes = {
            requerido: (v) => !!v || 'Este campo es obligatorio.',
            longitudMaxima: (max) => (v) =>
                (v && v.length <= max) ||
                `El campo no puede tener más de ${max} caracteres.`,
            longitudMinima: (min) => (v) =>
                (v && v.length >= min) ||
                `El campo debe tener al menos ${min} caracteres.`,
            soloLetras: (v) =>
                /^[A-Za-zÀ-ÖØ-öø-ÿ\s’'-]+$/u.test(v) ||
                'El campo solo puede contener letras, espacios, guiones y apóstrofes.',
            noCaracteresInicioFin: (v) =>
                !/^[\s’'-]|[\s’'-]$/.test(v) ||
                'El campo no puede comenzar o terminar con espacios, guiones o apóstrofes.',
            opcional: (regla) => (v) => !v || regla(v), // Función para campos opcionales
        };
        return {
            duplicateDialog: false,
            bypassDuplicate: false,
            lastFormData: null,
            patientId: '',
            patientName: '',
            fatherLastName: '',
            motherLastName: '',
            birthDate: '',
            patientGender: '',
            patientWeight: '',
            patientHeight: '',
            patientCard: '',
            notificationsCheckbox: true,
            patientOccupation: '',
            patientPhone: '',
            patientEmail: '',
            loadPatientInfo: false,
            inputPatientForm: false,
            isSubmitting: false,
            contactDialog: false,
            snackbar: false,
            snackbarMessage: '',
            snackbarColor: 'success',
            noContactCheckbox: false,

            inputTextRules: [
                reglasComunes.requerido,
                reglasComunes.longitudMaxima(30),
                reglasComunes.longitudMinima(2),
                reglasComunes.soloLetras,
                reglasComunes.noCaracteresInicioFin,
            ],
            motherLastNameRules: [
                reglasComunes.opcional(reglasComunes.longitudMaxima(30)),
                reglasComunes.opcional(reglasComunes.longitudMinima(2)),
                reglasComunes.opcional(reglasComunes.soloLetras),
                reglasComunes.opcional(reglasComunes.noCaracteresInicioFin),
            ],
            dateRules: [
                (v) => !!v || 'La fecha es obligatoria.',
                (v) =>
                    /^\d{2}\/\d{2}\/\d{4}$/.test(v) ||
                    'El formato debe ser DD/MM/AAAA',
                (v) => validateDate(v) || 'La fecha no es válida',
            ],
            genderRules: [(v) => !!v || 'El sexo es obligatorio.'],
            weightRules: [
                (v) =>
                    /^\d{2}\/\d{2}\/\d{4}$/.test(v) ||
                    'Solo se permiten numeros',
            ],
            emailRules: [
                (v) =>
                    !v ||
                    /^[\w.]+@[a-zA-Z_.]+?\.[a-zA-Z]{2,3}$/.test(v) ||
                    'Correo electrónico no válido',
                // reglasComunes.requerido,
            ],
            phoneRules: [
                (v) =>
                    !v ||
                    /^[0-9]{10}$/.test(v) ||
                    'Número de teléfono no válido',
                // reglasComunes.requerido,
            ],
            patientOccupationRules: [],
        };
    },
    computed: {
        hasContact() {
            return this.patientPhone || this.patientEmail;
        },
    },
    mounted() {
        //en caso de consultar para actualizar usuario
        if (this.$route.params.id) {
            this.patientId = this.$route.params.id;
            this.patientFillData();
        }
        this.patientName = this.$route.query.name || '';
        this.fatherLastName = this.$route.query.patientFatherLastName || '';
        this.motherLastName = this.$route.query.patientMotherLastName || '';
        this.birthDate = this.$route.query.patientBirthDate || '';
    },
    methods: {
        patientFillData() {
            getPatientById(this.patientId)
                .then((patient) => {
                    if (!patient || Object.keys(patient).length === 0) {
                        return;
                    }

                    const {
                        nombre,
                        primerApellido,
                        segundoApellido,
                        birthdate,
                        sexo,
                        card,
                        alert_notifications,
                        occupation,
                        telecom = [],
                    } = patient;

                    this.patientName = nombre;
                    this.fatherLastName = primerApellido;
                    this.motherLastName = segundoApellido;
                    this.birthDate = birthdate;
                    this.patientGender = sexo;
                    this.patientCard = card;
                    this.notificationsCheckbox = alert_notifications;
                    this.patientOccupation = occupation;

                    const telecomMap = telecom.reduce((acc, contact) => {
                        if (!acc[contact.type]) {
                            acc[contact.type] = contact.value;
                        }
                        return acc;
                    }, {});

                    this.patientPhone = telecomMap.Telefono || '';
                    this.patientEmail = telecomMap.Correo || '';
                    this.loadPatientInfo = true;
                })
                .catch((error) => {
                    console.error(error);
                });
        },
        enviarFormulario() {
            if (!this.hasContact) {
                this.contactDialog = true;
            } else {
                this.validarFormulario();
            }
        },
        submitWithBypass() {
            this.bypassDuplicate = true;
            this.duplicateDialog = false;
            const formData = {...this.lastFormData};

            // Si estamos en modo actualización
            if (this.loadPatientInfo) {
                putPacientes(this.patientId, formData, {}, this.bypassDuplicate)
                    .then(() => {
                        this.mostrarSnackbar(true, 'Paciente actualizado con éxito');
                        this.$router.push({
                            name: 'Expediente',
                            params: { id: this.patientId },
                        });
                    })
                    .catch(() => {
                        this.mostrarSnackbar(false, 'Error al actualizar el paciente');
                    })
                    .finally(() => {
                        this.bypassDuplicate = false;
                        this.isSubmitting = false;
                    });
            } else {
                postPaciente(formData, this.bypassDuplicate)
                    .then((response) => {
                        const formattedId = {
                            id: typeof response.id !== 'undefined'
                                ? response.id.split('/')[1]
                                : null,
                        };
                        if (formattedId.id) {
                            const searchParams = {
                                patientName: this.patientName,
                                fatherLastName: this.fatherLastName,
                                motherLastName: this.motherLastName,
                                birthDate: this.birthDate,
                            };
                            localStorage.setItem(
                                'searchParams',
                                JSON.stringify(searchParams),
                            );
                            this.resetForm();
                            this.mostrarSnackbar(true, 'Paciente creado con éxito');
                            this.$router.push({
                                name: 'CrearDiagnostico',
                                params: { id: formattedId.id },
                            });
                        }
                    })
                    .catch(() => {
                        this.mostrarSnackbar(false, 'Error en la creación del paciente');
                    })
                    .finally(() => {
                        this.bypassDuplicate = false;
                        this.isSubmitting = false;
                    });
            }
        },

        validarFormulario() {
            if (this.isSubmitting) return;
            this.isSubmitting = true;
            this.contactDialog = false; // Cerramos el modal preventivamente para evitar ventanas encimadas

            if (this.inputPatientForm) {
                if (this.loadPatientInfo) {
                    this.updatePatient();
                    setTimeout(() => {
                        this.isSubmitting = false;
                    }, 5000);
                } else {
                    const formData = this.parsePatientData();
                    this.lastFormData = formData;  // Guardamos los datos del formulario

                    postPaciente(formData)
                        .then((response) => {
                            const formattedId = {
                                id: typeof response.id !== 'undefined'
                                    ? response.id.split('/')[1]
                                    : null,
                            };
                            if (formattedId.id) {
                                const searchParams = {
                                    patientName: this.patientName,
                                    fatherLastName: this.fatherLastName,
                                    motherLastName: this.motherLastName,
                                    birthDate: this.birthDate,
                                };
                                localStorage.setItem(
                                    'searchParams',
                                    JSON.stringify(searchParams),
                                );
                                this.resetForm();
                                this.mostrarSnackbar(true, 'Paciente creado con éxito');
                                this.$router.push({
                                    name: 'CrearDiagnostico',
                                    params: { id: formattedId.id },
                                });
                            }
                        })
                        .catch((error) => {
                            console.error(error);
                            if (error.response && error.response.status === 422) {
                                this.duplicateDialog = true;
                            } else {
                                this.mostrarSnackbar(false, 'Error en la creación del paciente');
                            }
                        })
                        .finally(() => {
                            if (!this.duplicateDialog) {
                                this.isSubmitting = false;
                            }
                        });
                }
            } else {
                this.mostrarSnackbar(false, 'Error en la creación del paciente');
                this.isSubmitting = false;
            }
        },
        updatePatient() {
            const formData = this.parsePatientData();

            putPacientes(this.patientId, formData)
                .then(() => {
                    this.mostrarSnackbar(true, 'Paciente actualizado con éxito');
                    this.$router.push({
                        name: 'Expediente',
                        params: { id: this.patientId },
                    });
                })
                .catch((error) => {
                    if (error.response && error.response.status === 422) {
                        this.lastFormData = formData;
                        this.duplicateDialog = true;
                    } else {
                        this.mostrarSnackbar(
                            false,
                            error.response?.data?.data || 'Error al actualizar el paciente'
                        );
                    }
                })
                .finally(() => {
                    if (!this.duplicateDialog) {
                        this.isSubmitting = false;
                    }
                });
        },
        resetForm() {
            this.$refs.form.reset();
        },
        formatText(fieldName) {
            this[fieldName] = formatText(this[fieldName]);
        },
        formatDate(event) {
            this.birthDate = formatDate(event);
        },
        formatCardInput() {
            this.patientCard = this.patientCard
                .replace(/[^a-zA-Z0-9]/g, '')
                .slice(0, 15)
                .toUpperCase();
        },
        formatWeightInput() {
            this.patientWeight = this.patientWeight
                .replace(/[^0-9.]/g, '')
                .slice(0, 6);
        },
        formatHeightInput() {
            this.patientHeight = this.patientHeight
                .replace(/[^0-9]/g, '')
                .slice(0, 6);
        },
        //funciones para manejo de contactos
        getRules(type) {
            if (!type) return [];
            return type === 'Correo' ? this.emailRules : this.phoneRules;
        },
        mostrarSnackbar(status, mensaje) {
            this.snackbarMessage = mensaje;
            this.snackbarColor = status ? 'success' : 'error';
            this.snackbar = true;
        },
        parsePatientData() {
            const datos = [
                {
                    system: 'Telefono',
                    value: this.patientPhone,
                },
                {
                    system: 'Correo',
                    value: this.patientEmail,
                },
            ];

            const formData = {
                name: [this.patientName],
                lastName: [
                    this.fatherLastName ?? null,
                    this.motherLastName === "" ? null : this.motherLastName
                ],
                birthDate: this.birthDate,
                gender: this.patientGender,
                telecom: datos,
                loyalty_card: this.patientCard,
                patient_weight: (this.patientWeight !== null && this.patientWeight !== undefined && this.patientWeight !== '') ? parseFloat(this.patientWeight) : null,
                patient_height: (this.patientHeight !== null && this.patientHeight !== undefined && this.patientHeight !== '') ? parseFloat(this.patientHeight) : null,
                alert_notifications: this.notificationsCheckbox,
                occupation: this.patientOccupation,
            };

            const filteredFormData = Object.entries(formData).reduce(
                (acc, [key, value]) => {
                    if (
                        (Array.isArray(value) &&
                            value.some((v) => v != null && v !== '')) || // Filtrar arrays vacíos o con solo valores nulos
                        (value != null && value !== '') // Filtrar valores simples nulos o vacíos
                    ) {
                        acc[key] = value;
                    }
                    return acc;
                },
                {},
            );

            return filteredFormData;
        },
    },
};
</script>

<style scoped>
.container {
    background-color: #ffffff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    width: 90%;
    margin: 18px auto 0 auto;
    /* top right bottom left */
}

.date-picker-container {
    position: relative;
    display: inline-block;
}

.date-picker-overlay {
    position: absolute;
    top: calc(100% + 10px);
    left: 0;
    z-index: 9999;
}

.font {
    color: white;
}

/* .cont-boton {
    display: flex;
    flex-direction: row-reverse;
    margin-right: 5%;
    margin-top: 30px;
} */

.required {
    color: red;
}

.field-icon {
    font-size: 18pt;
    margin: 15px 12px;
    padding: auto;
    color: var(--celeste-electrico);
}

.field-input {
    color: var(--gris-urbano);
    font-family: 'Trebuchet MS';
}

.field-label {
    color: var(--celeste-electrico);
    font-weight: bold;
    font-family: 'Trebuchet MS';
    font-size: 13pt;
}

.required-field-icon {
    color: red;
    margin-left: -15px;
    font-family: 'Trebuchet MS';
    font-weight: bold;
}

.field-input :deep(.v-field-label) {
    opacity: 1 !important;
    transition: none !important;
}

.field-input :deep(.v-field__overlay) {
    opacity: 0 !important;
    background-color: transparent !important;
    transition: none !important;
}

.field-input :deep(.v-field__outline) {
    transition: none !important;
}

.field-input :deep(.v-field) {
    transition: none !important;
}
</style>
